__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/b8e3e47/packs/";